export enum TipoExtracaoEnum {
    NotaXml = 1,
    NotaCsv = 2,
    NotaRecebidaXml = 3,
    NotaRecebidaCsv = 4,
    RelatorioProdutoNFeNFCe = 5,
    ListaPessoas = 6,
    ProdutosCSV = 7,
    ComposicaoKitsCSV = 8,
    EstruturaFabricadosCSV = 9,
    CategoriaFinanceiraCSV = 10,
    ContasPagarCSV = 11,
    ContasReceberCSV = 12,
    ControleEstoqueCSV = 13,
    ControleEstoqueMovimentacoesCSV = 14,
    ControleEstoqueReservasCSV = 15,
    ControleEstoqueLotesCSV = 16,
    ControleEstoqueSeriesCSV = 17,
    NotasFiscaisEntradaCSV = 18,
    VendasCSV = 19,
    NotasFiscaisSaidaCSV = 20,
}
